import { render, staticRenderFns } from "./BaseInformation.vue?vue&type=template&id=c4ec5bca&scoped=true&"
import script from "./BaseInformation.vue?vue&type=script&lang=js&"
export * from "./BaseInformation.vue?vue&type=script&lang=js&"
import style0 from "./BaseInformation.vue?vue&type=style&index=0&id=c4ec5bca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec5bca",
  null
  
)

export default component.exports